import { Music, Drama, Trophy, PartyPopper, Mic, Shapes } from "lucide-react";

// Felles kategori-utseende for Right in: én dempet farge per kategori (tokens i index.css → --cat-*).
// Klassene skrives fullt ut slik at Tailwind JIT finner dem. Ukjent kategori faller tilbake til «Annet».
export const CATEGORY_STYLES = {
  Konsert: {
    key: "konsert",
    Icon: Music,
    text: "text-cat-konsert",
    stripe: "bg-cat-konsert",
    badge: "bg-cat-konsert-soft text-cat-konsert border-cat-konsert/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-konsert-soft hover:border-cat-konsert/30",
    chipActive: "bg-cat-konsert-soft text-cat-konsert border-cat-konsert/40",
    countIdle: "bg-cat-konsert-soft text-cat-konsert",
    countActive: "bg-cat-konsert text-white",
  },
  Teater: {
    key: "teater",
    Icon: Drama,
    text: "text-cat-teater",
    stripe: "bg-cat-teater",
    badge: "bg-cat-teater-soft text-cat-teater border-cat-teater/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-teater-soft hover:border-cat-teater/30",
    chipActive: "bg-cat-teater-soft text-cat-teater border-cat-teater/40",
    countIdle: "bg-cat-teater-soft text-cat-teater",
    countActive: "bg-cat-teater text-white",
  },
  Sport: {
    key: "sport",
    Icon: Trophy,
    text: "text-cat-sport",
    stripe: "bg-cat-sport",
    badge: "bg-cat-sport-soft text-cat-sport border-cat-sport/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-sport-soft hover:border-cat-sport/30",
    chipActive: "bg-cat-sport-soft text-cat-sport border-cat-sport/40",
    countIdle: "bg-cat-sport-soft text-cat-sport",
    countActive: "bg-cat-sport text-white",
  },
  Festival: {
    key: "festival",
    Icon: PartyPopper,
    text: "text-cat-festival",
    stripe: "bg-cat-festival",
    badge: "bg-cat-festival-soft text-cat-festival border-cat-festival/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-festival-soft hover:border-cat-festival/30",
    chipActive: "bg-cat-festival-soft text-cat-festival border-cat-festival/40",
    countIdle: "bg-cat-festival-soft text-cat-festival",
    countActive: "bg-cat-festival text-white",
  },
  Foredrag: {
    key: "foredrag",
    Icon: Mic,
    text: "text-cat-foredrag",
    stripe: "bg-cat-foredrag",
    badge: "bg-cat-foredrag-soft text-cat-foredrag border-cat-foredrag/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-foredrag-soft hover:border-cat-foredrag/30",
    chipActive: "bg-cat-foredrag-soft text-cat-foredrag border-cat-foredrag/40",
    countIdle: "bg-cat-foredrag-soft text-cat-foredrag",
    countActive: "bg-cat-foredrag text-white",
  },
  Annet: {
    key: "annet",
    Icon: Shapes,
    text: "text-cat-annet",
    stripe: "bg-cat-annet",
    badge: "bg-cat-annet-soft text-cat-annet border-cat-annet/25",
    chipIdle: "bg-card text-foreground border-border hover:bg-cat-annet-soft hover:border-cat-annet/30",
    chipActive: "bg-cat-annet-soft text-cat-annet border-cat-annet/40",
    countIdle: "bg-cat-annet-soft text-cat-annet",
    countActive: "bg-cat-annet text-white",
  },
};

// Rekkefølgen brukes til kategori-snarveiene på forsiden
export const CATEGORY_ORDER = ["Konsert", "Teater", "Sport", "Festival", "Foredrag", "Annet"];

export function categoryStyle(category) {
  return CATEGORY_STYLES[category] || CATEGORY_STYLES.Annet;
}
